import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Currency, TrackingEvents } from './enums';
import { track } from './tracking-track';
export const getTrackingData = (position, productId, ratings, trackingInfo) => {
  return {
    position,
    productId,
    ratingavg: ratings ? ratings.average : undefined,
    ratingtotal: ratings ? ratings.count : undefined,
    list: trackingInfo
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const extractTrackingInfoFromArticle = (article, index) => {
  const position = index + 1;
  const {
    ratings,
    tracking_information,
    tracking_information_retailer
  } = article;
  const defaultTrackingInformation = tracking_information ? JSON.parse(tracking_information) : undefined;
  const retailerTrackingInformation = tracking_information_retailer ? JSON.parse(tracking_information_retailer) : undefined;
  let trackOnClick;
  let trackingInformation;
  if (retailerTrackingInformation) {
    // eslint-disable-next-line
    trackOnClick = trackRetailerArticleClick;
    trackingInformation = retailerTrackingInformation;
  } else {
    // eslint-disable-next-line
    trackOnClick = trackArticleClick;
    trackingInformation = defaultTrackingInformation;
  }
  return {
    position,
    trackOnClick,
    defaultTrackingInformation,
    trackingInformation,
    ratings
  };
};
export const trackArticleTileImpression = (position, trackingInformation, productId, trackingInfo, ratings) => {
  const data = _objectSpread(_objectSpread({}, trackingInformation), getTrackingData(position, productId, ratings, trackingInfo));
  track(TrackingEvents.productImpression, {
    ecommerce: {
      currencyCode: Currency.chf,
      impressions: [data]
    }
  });
};
export const trackArticleClick = async (position, trackingInformation, productId, ratings, trackingInfo) => {
  let data = getTrackingData(position, productId, ratings, trackingInfo);
  data = _objectSpread(_objectSpread({}, trackingInformation), data);
  track(TrackingEvents.productClick, {
    ecommerce: {
      click: {
        actionField: {
          list: trackingInfo
        },
        products: [data]
      }
    }
  });
};
export const trackRetailerArticleClick = async (position, trackingInformation, productId, ratings, trackingInfo) => {
  let data = getTrackingData(position, productId, ratings, trackingInfo);
  data = _objectSpread(_objectSpread({}, trackingInformation), data);
  track(TrackingEvents.addToCart, {
    ecommerce: {
      add: {
        products: [data]
      },
      currencyCode: Currency.chf
    }
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const trackSliderMovement = (ref, direction) => {
  const sliderParentElement = ref.current ? ref.current.parentElement : null;
  const data = {
    sliderMovement: direction,
    sliderElement: sliderParentElement ? sliderParentElement.className : null,
    sliderType: 'manuell'
  };
  track(TrackingEvents.slider, data);
};